export enum CMS {
  GTM = 'gtm',
  WORDPRESS = 'wordpress',
  SHOPIFY = 'shopify',
  WIX = 'wix',
  MAGENTO = 'magento',
  SQUARESPACE = 'squarespace',
  DRUPAL = 'drupal',
  PRESTASHOP = 'prestashop',
  CLICKFUNNELS = 'clickfunnels',
  WOOCOMMERCE = 'woocommerce',
}

export interface PlatformGuide {
  icon: string;
  url: string;
  title: string;
  subText: string;
  instructions: string;
  showVerify?: boolean;
  showSiteId?: boolean;
}

export interface PlatformGuides {
  [cms: string]: PlatformGuide;
}

export const guidesByPlatform: PlatformGuides = {
  gtm: {
    icon: 'icon-gtm',
    url: '/articles/360022882854-How-to-Install-Hotjar-on-Google-Tag-Manager-as-Custom-HTML',
    title: 'Google Tag Manager',
    subText: "Connect with this platform and you're done!",
    instructions:
      'Follow the Google Tag Manager installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
  wordpress: {
    icon: 'icon-wordpress',
    url: '/articles/115009340247-WordPress-',
    title: 'WordPress',
    subText: "Install our official plugin and you're done!",
    instructions: 'Add our official Hotjar plugin to your WordPress site and enter your site ID.',
    showSiteId: true,
  },
  shopify: {
    icon: 'icon-shopify',
    url: '/articles/115009502848-Shopify',
    title: 'Shopify',
    subText: "Connect with this platform and you're done!",
    instructions: 'Follow the Shopify installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
  wix: {
    icon: 'icon-wix',
    url: '/articles/115009340207-Wix',
    title: 'Wix',
    subText: "Connect with this platform and you're done!",
    instructions: 'Follow the Wix installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
  magento: {
    icon: 'icon-magento',
    url: '/articles/115009502448-Magento',
    title: 'Magento',
    subText: "Connect with this platform and you're done!",
    instructions: 'Follow the Magento installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
  squarespace: {
    icon: 'icon-squarespace',
    url: '/articles/115009503028-SquareSpace',
    title: 'SquareSpace',
    subText: "Connect with this platform and you're done!",
    instructions: 'Follow the SquareSpace installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
  drupal: {
    icon: 'icon-drupal',
    url: '/articles/115009499608-Drupal',
    title: 'Drupal',
    subText: "Connect with this platform and you're done!",
    instructions: 'Follow the Drupal installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
  prestashop: {
    icon: 'icon-prestashop',
    url: '/articles/115009339927-Prestashop',
    title: 'PrestaShop',
    subText: "Connect with this platform and you're done!",
    instructions: 'Follow the PrestaShop installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
  clickfunnels: {
    icon: 'icon-clickfunnels',
    url: '/articles/360000733574-ClickFunnels',
    title: 'ClickFunnels',
    subText: "Connect with this platform and you're done!",
    instructions: 'Follow the ClickFunnels installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
  woocommerce: {
    icon: 'icon-woocommerce',
    url: '/articles/360000729133-WooCommerce-',
    title: 'WooCommerce',
    subText: "Connect with this platform and you're done!",
    instructions: 'Follow the WooCommerce installation guide to connect Hotjar to your site.',
    showVerify: true,
  },
};
